import Constants from "~/helpers/enums/Constants";
import getBookingTransactionService from "~/services/bookingTransactionService";

const getBookingTransaction = (id) => (dispatch) => {
	getBookingTransactionService.getBookingTransaction(id).then(({ data }) => {
		dispatch({ type: Constants.GET_BOOKING_TRANSACTION, payload: { bookingTransaction: data } });
	});
};
export default { getBookingTransaction };
